import { __values } from 'tslib';
import { Subject, of, from } from 'rxjs';
import { Pipe, ChangeDetectorRef, Directive, Input, HostBinding, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Loader = /** @class */ (function () {
    function Loader() {
    }
    /**
     * @param {?} url
     * @return {?}
     */
    Loader.prototype.load = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return new Promise(function (resolve, reject) {
            /** @type {?} */
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onload = function () {
                if (xhr.status === 200) {
                    try {
                        resolve(JSON.parse(xhr.responseText));
                    }
                    catch (e) {
                        reject("Parse Error: Invalid JSON");
                    }
                }
                else {
                    reject(xhr.statusText);
                }
            };
            xhr.onerror = function () {
                reject('Network Error');
            };
            xhr.send();
        });
    };
    return Loader;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} obj
 * @return {?}
 */
function isObject(obj) {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
}
/**
 * @param {?} obj
 * @return {?}
 */
function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}
/**
 * @param {...?} args
 * @return {?}
 */
function mergeDeep() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    /** @type {?} */
    var startIndex = 1;
    /** @type {?} */
    var output = Object(args[0] || {});
    // Cycle the source object arguments.
    for (var a = startIndex; a < args.length; a++) {
        /** @type {?} */
        var from$$1 = args[a];
        /** @type {?} */
        var keys = Object.keys(Object(from$$1));
        // Cycle the properties.
        for (var k = 0; k < keys.length; k++) {
            /** @type {?} */
            var key = keys[k];
            // Merge arrays.
            if (Array.isArray(output[key]) || Array.isArray(from$$1[key])) {
                /** @type {?} */
                var o = Array.isArray(output[key]) ? output[key].slice() : [];
                /** @type {?} */
                var f = Array.isArray(from$$1[key]) ? from$$1[key].slice() : [];
                output[key] = o.concat(f);
            }
            else if (isFunction(output[key]) || isFunction(from$$1[key])) {
                // Copy functions references.
                output[key] = from$$1[key];
            }
            else if (isObject(output[key]) || isObject(from$$1[key])) {
                // Extend objects.
                output[key] = mergeDeep(output[key], from$$1[key]);
            }
            else {
                // Copy all other types.
                output[key] = from$$1[key];
            }
        }
    }
    return output;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var currencyOverridesMap = {
    PLN: 'zł',
    SGD: 'S$',
    HUF: 'Ft',
    DKK: 'kr.',
    SEK: 'kr',
    NOK: 'kr',
    ZAR: 'R',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Formats = /** @class */ (function () {
    function Formats() {
        // Format formatDefaults
        this.defaults = {
            number: {},
            currency: {},
            date: {},
        };
        // Initially set the locale to the browser
        this.setLocale(window.navigator.language);
    }
    /**
     * @param {?} overrides
     * @return {?}
     */
    Formats.prototype.override = /**
     * @param {?} overrides
     * @return {?}
     */
    function (overrides) {
        if (overrides.locale) {
            this.setLocale(overrides.locale);
            delete overrides['locale'];
        }
        this.defaults = overrides;
    };
    /**
     * @param {?} locale
     * @return {?}
     */
    Formats.prototype.setLocale = /**
     * @param {?} locale
     * @return {?}
     */
    function (locale) {
        this.locale = locale;
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Formats.prototype.formatNumber = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        /** @type {?} */
        var _format = mergeDeep({}, this.defaults.number, format);
        return new Intl.NumberFormat([this.locale, 'en-US'], _format).format(value);
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Formats.prototype.formatCurrency = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        /** @type {?} */
        var _format = typeof format === 'string'
            ? mergeDeep({}, { currency: format }, this.defaults.currency)
            : mergeDeep({}, format, this.defaults.currency);
        /** @type {?} */
        var options = mergeDeep({ style: 'currency', currency: 'USD' }, _format);
        if (this.overrideCurrency) {
            if (this.overrideCurrency === 'None') {
                return new Intl.NumberFormat([this.locale, 'en-US'], { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
            }
            options.currency = this.overrideCurrency;
        }
        /** @type {?} */
        var currencyValue = new Intl.NumberFormat([this.locale, 'en-US'], options).format(value);
        return currencyOverridesMap[options.currency]
            ? currencyValue.replace(options.currency, currencyOverridesMap[options.currency])
            : currencyValue;
    };
    /**
     * @param {?} format
     * @return {?}
     */
    Formats.prototype.getDateOptions = /**
     * @param {?} format
     * @return {?}
     */
    function (format) {
        /** @type {?} */
        var shortHands = mergeDeep({}, this.defaults.date);
        /** @type {?} */
        var options = typeof format === 'string' ? shortHands[format] : format;
        if (!options || Object.keys(options).length === 0) {
            options = shortHands.dateShort;
        }
        if (this.use24HourTime) {
            options.hour12 = false;
        }
        return options;
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Formats.prototype.formatDate = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        /** @type {?} */
        var _value = value === null || value === undefined || value === '' ? new Date() : new Date(value);
        /** @type {?} */
        var options = this.getDateOptions(format);
        return new Intl.DateTimeFormat([this.locale, 'en-US'], options).format(_value);
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Formats.prototype.formatTime = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        /** @type {?} */
        var _value = (value === null || value === undefined || value === '') ? new Date() : new Date(value);
        /** @type {?} */
        var options = this.getDateOptions(format);
        /** @type {?} */
        var timeParts = Intl.DateTimeFormat([this.locale, 'en-US'], options).formatToParts(_value).reduce(function (obj, part) {
            obj[part.type] = part.value;
            return obj;
        }, {});
        /** @type {?} */
        var dayPeriodPropertyName = Object.keys(timeParts).find(function (n) { return n.toLowerCase() === 'dayperiod'; });
        /** @type {?} */
        var dayperiod = timeParts[dayPeriodPropertyName] || '';
        return timeParts.hour + ":" + timeParts.minute + dayperiod;
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Formats.prototype.format = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        if (!value) {
            return value;
        }
        switch (format) {
            case 'uppercase':
                return value.toUpperCase();
            case 'lowercase':
                return value.toLowerCase();
            case 'title':
                return value.replace(/\w\S*/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            case 'denormalize':
                return value.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
                    return str.toUpperCase();
                });
            default:
                return value;
        }
    };
    return Formats;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DictionaryManager = /** @class */ (function () {
    function DictionaryManager() {
        this.dictionaries = {};
    }
    /**
     * @param {?} locale
     * @return {?}
     */
    DictionaryManager.prototype.contains = /**
     * @param {?} locale
     * @return {?}
     */
    function (locale) {
        return !!this.dictionaries[locale];
    };
    /**
     * @param {?} locale
     * @return {?}
     */
    DictionaryManager.prototype.get = /**
     * @param {?} locale
     * @return {?}
     */
    function (locale) {
        return this.dictionaries[locale] || this.dictionaries[locale.split('-')[0]];
    };
    /**
     * @param {?} locale
     * @param {?} translations
     * @param {?} fallbackTranslations
     * @return {?}
     */
    DictionaryManager.prototype.add = /**
     * @param {?} locale
     * @param {?} translations
     * @param {?} fallbackTranslations
     * @return {?}
     */
    function (locale, translations, fallbackTranslations) {
        this.dictionaries[locale] = mergeDeep({}, fallbackTranslations, translations);
    };
    return DictionaryManager;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Default formats
/** @type {?} */
var FORMAT_DEFAULTS = {
    number: {
        style: 'decimal',
    },
    currency: {
        style: 'currency',
        currency: 'USD',
    },
    date: {
        short: {
            // DD/MM/YYYY, HH:MM A - 02/14/2017, 1:17 PM
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        },
        medium: {
            // MMM DD, YYYY, HH:MM A - Feb 14, 2017, 1:17 PM
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        },
        long: {
            // MMMM DD, YYYY, HH:MM A - Febuary 14, 2017, 1:17 PM
            month: 'long',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        },
        dateShort: {
            // DEFAULT: DD/MM/YYYY - 02/14/2017
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        },
        dateMedium: {
            // MMM DD, YYYY - Feb 14, 2017
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        },
        dateLong: {
            // MMMM DD, YYYY - Febuary 14, 2017
            month: 'long',
            day: '2-digit',
            year: 'numeric',
        },
        timeShort: {
            // HH:MM A - 1:17 PM
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        },
        timeLong: {
            // HH:MM A Z - 1:17 PM CST
            hour: '2-digit',
            minute: '2-digit',
            timeZoneName: 'short',
            hour12: true,
        },
    },
};
var Chomsky = /** @class */ (function () {
    function Chomsky(locale) {
        // Loader to load translations from a JSON file
        this.loader = new Loader();
        // Default location for translations
        this.location = 'i18n/';
        // Current locale
        this.currentLocale = window.navigator.language;
        // Dictionary Manger to handle translations that have been loaded
        this.dictionaryManager = new DictionaryManager();
        // Custom formats based on the locale
        this.formats = new Formats();
        // Object for default replacements, so users don't have to pass around each time
        this.defaultReplacements = {};
        // Handle for when the locale changes
        this.onLocaleChange = new Subject();
        if (locale) {
            this.use(locale);
        }
    }
    /**
     * @param {?} location
     * @return {?}
     */
    Chomsky.prototype.setLocation = /**
     * @param {?} location
     * @return {?}
     */
    function (location) {
        this.location = location;
    };
    /**
     * @param {?} defaultReplacements
     * @return {?}
     */
    Chomsky.prototype.setDefaultReplacements = /**
     * @param {?} defaultReplacements
     * @return {?}
     */
    function (defaultReplacements) {
        this.defaultReplacements = defaultReplacements;
    };
    /**
     * @param {?} currency
     * @return {?}
     */
    Chomsky.prototype.overrideCurrency = /**
     * @param {?} currency
     * @return {?}
     */
    function (currency) {
        this.formats.overrideCurrency = currency;
    };
    /**
     * @param {?} use24HourTime
     * @return {?}
     */
    Chomsky.prototype.forceDisplayTo24HourTime = /**
     * @param {?} use24HourTime
     * @return {?}
     */
    function (use24HourTime) {
        this.formats.use24HourTime = use24HourTime;
    };
    /**
     * @param {?} locale
     * @return {?}
     */
    Chomsky.prototype.use = /**
     * @param {?} locale
     * @return {?}
     */
    function (locale) {
        // Capture the pending task
        /** @type {?} */
        var pending;
        // If we don't have the translations, load them
        if (!this.dictionaryManager.get(locale)) {
            pending = this.getTranslations(locale);
        }
        // Return the pending if we are fetching
        if (typeof pending !== 'undefined') {
            return pending;
        }
        else {
            // Split out the language code from the locale
            /** @type {?} */
            var languageCode = (locale.split('-')[0] || '').toLowerCase();
            // Return the translations if they are already loaded
            /** @type {?} */
            var currentTranslations = [this.dictionaryManager.get(locale), this.dictionaryManager.get(languageCode)];
            this.applyLanguage(locale, currentTranslations[0], currentTranslations[1]);
            return of(currentTranslations);
        }
    };
    /**
     * @param {?} key
     * @param {?=} interpolation
     * @return {?}
     */
    Chomsky.prototype.translate = /**
     * @param {?} key
     * @param {?=} interpolation
     * @return {?}
     */
    function (key, interpolation) {
        var _this = this;
        /** @type {?} */
        var value = this.getValue(key);
        // Handle pluralization
        if (value && typeof value === 'object') {
            if (typeof interpolation === 'object') {
                /** @type {?} */
                var gender = interpolation.gender || 'other';
                if (gender) {
                    if (interpolation.quantity === 0 || interpolation.quantity) {
                        if (value[gender].hasOwnProperty(interpolation.quantity)) {
                            value = value[gender][interpolation.quantity];
                        }
                        else {
                            if (interpolation.quantity === 0) {
                                value = value[gender].zero;
                            }
                            else {
                                value = value[gender].many;
                            }
                        }
                    }
                    else {
                        throw new Error('Missing "quantity" property on the replacements!');
                    }
                }
            }
        }
        // Handle interpolation
        if ((interpolation || this.defaultReplacements) && value) {
            /** @type {?} */
            var replacements_1 = Object.assign({}, this.defaultReplacements, interpolation);
            value = value.replace(/{([^}]*)}/gi, function (m, param) {
                var e_1, _a;
                /** @type {?} */
                var params = param.split(':');
                if (params.length === 1) {
                    /** @type {?} */
                    var match = '';
                    if (replacements_1.hasOwnProperty(param)) {
                        match = replacements_1[param];
                    }
                    else {
                        match = replacements_1;
                    }
                    return match;
                }
                /** @type {?} */
                var unparsedValue = replacements_1[params[0]] || interpolation;
                switch (params[1]) {
                    case 'date':
                        return _this.formatDate(unparsedValue, params[2]);
                    case 'currency':
                        return _this.formatCurrency(unparsedValue, params[2]);
                    case 'number':
                        return _this.formatNumber(unparsedValue, params[2]);
                    case 'format':
                        /** @type {?} */
                        var formats = params[2].split(',');
                        /** @type {?} */
                        var formattedString = unparsedValue;
                        if (formats.length) {
                            try {
                                for (var formats_1 = __values(formats), formats_1_1 = formats_1.next(); !formats_1_1.done; formats_1_1 = formats_1.next()) {
                                    var format = formats_1_1.value;
                                    formattedString = _this.format(formattedString, format);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (formats_1_1 && !formats_1_1.done && (_a = formats_1.return)) _a.call(formats_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        else {
                            formattedString = _this.format(unparsedValue, params[2]);
                        }
                        return formattedString;
                    default:
                        return '';
                }
            });
        }
        // Return the key if no value is present.
        return value || key;
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Chomsky.prototype.format = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        return this.formats.format(value, format);
    };
    /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    Chomsky.prototype.formatDate = /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    function (date, format) {
        return this.formats.formatDate(date, format);
    };
    /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    Chomsky.prototype.formatTime = /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    function (date, format) {
        return this.formats.formatTime(date, format);
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Chomsky.prototype.formatCurrency = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        return this.formats.formatCurrency(value, format);
    };
    /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    Chomsky.prototype.formatNumber = /**
     * @param {?} value
     * @param {?=} format
     * @return {?}
     */
    function (value, format) {
        return this.formats.formatNumber(value, format);
    };
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    Chomsky.prototype.getValue = /**
     * @private
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var value;
        /** @type {?} */
        var translations = this.dictionaryManager.get(this.currentLocale);
        if (translations) {
            /** @type {?} */
            var tokens = key.split('.');
            value = translations[tokens[0]];
            if (value) {
                for (var i = 1; i < tokens.length; i++) {
                    if (!value) {
                        value = translations[tokens[i]];
                    }
                    else {
                        value = value[tokens[i]];
                    }
                }
            }
        }
        return value;
    };
    /**
     * @private
     * @param {?} locale
     * @return {?}
     */
    Chomsky.prototype.getTranslations = /**
     * @private
     * @param {?} locale
     * @return {?}
     */
    function (locale) {
        var _this = this;
        // Split out the language code from the locale
        /** @type {?} */
        var languageCode = (locale.split('-')[0] || '').toLowerCase();
        // Fetch the fallback language first
        return from(new Promise(function (resolve, reject) {
            _this.translationFetcher(languageCode).then(function (fallbackTranslations) {
                _this.translationFetcher(locale).then(function (translations) {
                    _this.applyLanguage(locale, translations, fallbackTranslations);
                    resolve(true);
                }, function (error) {
                    console.error("[Chomsky] - Cannot find the locale translation file! (" + locale + "):", error);
                    _this.applyLanguage(locale, {}, fallbackTranslations);
                    resolve(true);
                });
            }, function (error) {
                console.error("[Chomsky] - Cannot find the base translation file! (" + languageCode + "):", error);
                _this.applyLanguage(locale, {}, {});
                resolve(true);
            });
        }));
    };
    /**
     * @private
     * @param {?} locale
     * @param {?} translations
     * @param {?} fallbackTranslations
     * @return {?}
     */
    Chomsky.prototype.applyLanguage = /**
     * @private
     * @param {?} locale
     * @param {?} translations
     * @param {?} fallbackTranslations
     * @return {?}
     */
    function (locale, translations, fallbackTranslations) {
        // Set current locale
        this.currentLocale = locale;
        // Set locale on formats too
        this.formats.setLocale(locale);
        // Handle overrides
        /** @type {?} */
        var overrides = {};
        if (translations && translations.hasOwnProperty('_defaults_')) {
            mergeDeep(overrides, translations._defaults_);
            delete translations['_defaults_'];
        }
        if (fallbackTranslations && fallbackTranslations.hasOwnProperty('_defaults_')) {
            mergeDeep(overrides, fallbackTranslations._defaults_);
            delete translations['_defaults_'];
        }
        this.formats.override(mergeDeep({}, FORMAT_DEFAULTS, overrides));
        // Add the translations to the DictionaryManager
        this.dictionaryManager.add(locale, translations, fallbackTranslations);
        // Emit a change event
        this.onLocaleChange.next(locale);
    };
    /**
     * @private
     * @param {?} locale
     * @return {?}
     */
    Chomsky.prototype.translationFetcher = /**
     * @private
     * @param {?} locale
     * @return {?}
     */
    function (locale) {
        return this.loader.load("" + this.location + locale + ".json");
    };
    return Chomsky;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TranslateService = new Chomsky();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TranslatePipe = /** @class */ (function () {
    function TranslatePipe(changeDetector) {
        this.changeDetector = changeDetector;
        this.lastKey = '';
        this.lastParams = '';
        this.onLangChange = null;
        this.changeDetector = changeDetector;
    }
    /**
     * @param {?} objectOne
     * @param {?} objectTwo
     * @return {?}
     */
    TranslatePipe.prototype.equals = /**
     * @param {?} objectOne
     * @param {?} objectTwo
     * @return {?}
     */
    function (objectOne, objectTwo) {
        if (objectOne === objectTwo) {
            return true;
        }
        if (objectOne === null || objectTwo === null) {
            return false;
        }
        /** @type {?} */
        var typeOne = typeof objectOne;
        /** @type {?} */
        var typeTwo = typeof objectTwo;
        /** @type {?} */
        var length;
        /** @type {?} */
        var key;
        /** @type {?} */
        var keySet;
        if (typeOne === typeTwo && typeOne === 'object') {
            if (Array.isArray(objectOne)) {
                // Array checker
                if (!Array.isArray(objectTwo)) {
                    return false;
                }
                if ((length = objectOne.length) === objectTwo.length) {
                    for (key = 0; key < length; key++) {
                        if (!this.equals(objectOne[key], objectTwo[key])) {
                            return false;
                        }
                    }
                    return true;
                }
            }
            else {
                // Object checker
                if (Array.isArray(objectTwo)) {
                    return false;
                }
                keySet = Object.create(null);
                for (key in objectOne) {
                    if (key) {
                        if (!this.equals(objectOne[key], objectTwo[key])) {
                            return false;
                        }
                        keySet[key] = true;
                    }
                }
                for (key in objectTwo) {
                    if (!(key in keySet) && typeof objectTwo[key] !== 'undefined') {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    };
    /**
     * @return {?}
     */
    TranslatePipe.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe();
    };
    /**
     * @param {?} phraseKey
     * @param {?} dynamicVariables
     * @return {?}
     */
    TranslatePipe.prototype.updateValue = /**
     * @param {?} phraseKey
     * @param {?} dynamicVariables
     * @return {?}
     */
    function (phraseKey, dynamicVariables) {
        this.value = TranslateService.translate(phraseKey, dynamicVariables);
        this.changeDetector.markForCheck();
    };
    /**
     * @param {?} phraseKey
     * @param {?=} dynamicVariables
     * @return {?}
     */
    TranslatePipe.prototype.transform = /**
     * @param {?} phraseKey
     * @param {?=} dynamicVariables
     * @return {?}
     */
    function (phraseKey, dynamicVariables) {
        var _this = this;
        if (!phraseKey || phraseKey.length === 0) {
            return null;
        }
        if (this.equals(phraseKey, this.lastKey) && this.equals(dynamicVariables, this.lastParams)) {
            return this.value;
        }
        this.lastKey = phraseKey;
        this.lastParams = dynamicVariables;
        this.updateValue(phraseKey, dynamicVariables);
        this.unsubscribe();
        this.onLangChange = TranslateService.onLocaleChange.subscribe(function () {
            _this.updateValue(phraseKey, dynamicVariables);
        });
        return this.value;
    };
    /**
     * @return {?}
     */
    TranslatePipe.prototype.unsubscribe = /**
     * @return {?}
     */
    function () {
        if (this.onLangChange) {
            this.onLangChange.unsubscribe();
            this.onLangChange = undefined;
        }
    };
    TranslatePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'translate',
                    pure: false,
                },] }
    ];
    /** @nocollapse */
    TranslatePipe.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    return TranslatePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TranslateDirective = /** @class */ (function () {
    function TranslateDirective(sanitizer) {
        this.sanitizer = sanitizer;
    }
    Object.defineProperty(TranslateDirective.prototype, "innerHTML", {
        get: /**
         * @return {?}
         */
        function () {
            return this.translatedValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TranslateDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        TranslateService.onLocaleChange.subscribe(function () {
            _this.translatedValue = _this.renderContent(_this.translate, _this.dynamicValues);
        });
        this.translatedValue = this.renderContent(this.translate, this.dynamicValues);
    };
    /**
     * @return {?}
     */
    TranslateDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        TranslateService.onLocaleChange.unsubscribe();
    };
    /**
     * @param {?} key
     * @param {?} interpolation
     * @return {?}
     */
    TranslateDirective.prototype.renderContent = /**
     * @param {?} key
     * @param {?} interpolation
     * @return {?}
     */
    function (key, interpolation) {
        return this.sanitizer.bypassSecurityTrustHtml(TranslateService.translate(key, interpolation));
    };
    TranslateDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[translate]',
                },] }
    ];
    /** @nocollapse */
    TranslateDirective.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    TranslateDirective.propDecorators = {
        translate: [{ type: Input }],
        dynamicValues: [{ type: Input }],
        innerHTML: [{ type: HostBinding, args: ['innerHTML',] }]
    };
    return TranslateDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ChomskyModule = /** @class */ (function () {
    function ChomskyModule() {
    }
    ChomskyModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TranslatePipe, TranslateDirective],
                    exports: [TranslatePipe, TranslateDirective],
                },] }
    ];
    return ChomskyModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ChomskyModule, TranslateDirective, TranslatePipe, TranslateService, Chomsky as ɵa };

//# sourceMappingURL=chomsky.js.map